import { ManagementType } from "@/views/enums/subscriptionAction";

/**
 * Thông tin hiển thị gói cước (số cuộc họp, số CH đồng thời, số người tham gia, thời lượng cuộc họp)
 * @param active
 * @param plan
 * @returns Array<{ key: string, value: any }>
 */
export function buildCustomerPackageItems(active, plan) {
  if (!plan || !active) return [];

  if (plan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL) {
    return [
      { key: "displayActiveSubMaxParticipantsPool", value: active.maxParticipantPool ?? plan.maxParticipantPool },
      { key: "displayActiveSubMaxMeetingLength", value: plan.maximumLengthOfOneMeeting },
      { key: "displayActiveSubMeetingCount", value: plan.numberOfMeetingsPerMonth }
    ];
  }

  return [
    { key: "displayActiveSubMeetingCount", value: plan.numberOfMeetingsPerMonth },
    { key: "displayActiveSubConcurrentMeetings", value: active.numberOfConcurrentMeetings ?? plan.numberOfConcurrentMeetings },
    { key: "displayActiveSubMaxParticipants", value: active.meetingConcurrentParticipantsLimit ?? plan.maximumNumberOfParticipantsInMeeting },
    { key: "displayActiveSubMaxMeetingLength", value: plan.maximumLengthOfOneMeeting }
  ];
}

/**
 * Trả về danh sách thông số nhãn tĩnh (dùng cho các Modal Gia hạn, Nâng cấp, Đăng ký dịch vụ)
 * @param active
 * @param plan
 * @returns Array<{ label: string, value: any, suffix?: string }>
 */
export function buildPlanInfoRows(active, plan) {
  if (!plan || !active) return [];
  if (plan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL) {
    return [
      { label: "maxParticipantPool", value: active.maxParticipantPool ?? plan.maxParticipantPool },
      { label: "maximumLengthOfOneMeeting", value: plan.maximumLengthOfOneMeeting, suffix: "minutes" },
      { label: "numberOfMeetingsPerMonth", value: plan.numberOfMeetingsPerMonth }
    ];
  } else {
    return [
      { label: "maximumNumberOfParticipantsInMeeting", value: active.meetingConcurrentParticipantsLimit ?? plan.maximumNumberOfParticipantsInMeeting },
      { label: "numberOfConcurrentMeetings", value: active.numberOfConcurrentMeetings ?? plan.numberOfConcurrentMeetings },
      { label: "maximumLengthOfOneMeeting", value: plan.maximumLengthOfOneMeeting, suffix: "minutes" },
      { label: "numberOfMeetingsPerMonth", value: plan.numberOfMeetingsPerMonth }
    ];
  }
}
